import React from 'react';
import styled from 'styled-components';

const Space = styled.div<any>`
  height: ${(p) => p.space};
`;

const VerticalSpacer = ({ space = '1em' }) => {
  return <Space space={space}></Space>;
};

export default VerticalSpacer;
